module.exports = __webpack_public_path__ + "img/fig40.7cb842dd.jpg";